// @flow

import styled, { css } from 'styled-components';
import { Container } from '@components/index';
import { HeadingWithHTMLContainer } from '@components/headingWithHTML';
import { LinkButton } from '@components/button/simple';
import {
  media, grid, gridArea, gridTemplateColumns,
} from '@helpers/index';
import type { Theme } from '@types/index';

export const Content = styled<any, Theme>('section')`
  ${gridArea('1 / 1 / 2 / 3')}

  ${media.md(css`
    ${gridArea('1 / 2 / 2 / 3')}
  `)}
`;

export const PageNotFoundContainer = styled<typeof Container, Theme>(Container)`
  ${grid()}
  ${gridTemplateColumns('1fr 1fr')}

  ${/* sc-sel */HeadingWithHTMLContainer} {
    padding-bottom: 2rem;
  }

  > picture {
    ${gridArea('1 / 1 / 2 / 2')}
    display: none;

    ${media.md(css`
      display: block;
    `)}
  }
`;

const ButtonBarColumnView = css`
  flex-direction: column;
  flex-wrap: nowrap;

  ${/* sc-sel */LinkButton} {
    margin: 0 0 1rem;
    width: 100%;
  }
`;

const ButtonBarRowView = css`
  flex-direction: row;

  ${/* sc-sel */LinkButton} {
    margin: 0 1rem 0 0;
    width: 100%;
  }
`;

export const ButtonBar = styled<any, Theme>('section')`
  align-items: center;
  box-sizing: border-box;
  display: flex;
  justify-items: center;

  ${ButtonBarColumnView}

  ${/* sc-sel */LinkButton} {
    &:last-of-type {
      margin: 0;
    }
  }

  ${media.sm(ButtonBarRowView)}
  ${media.md(ButtonBarColumnView)}
  ${media.lg(ButtonBarRowView)}
`;

export default null;
